module.exports = __webpack_public_path__ + "img/technical.ad97852.svg";